import { NotificationItemTypeId } from '@ninety/platform/models/notifications/notification-item-type';
import { NotificationReason, NotificationReasonId } from '@ninety/platform/models/notifications/notification-reason';

export interface NotificationChannel {
  email: boolean;
  web: boolean;
  mobile: boolean;
}

export interface FeedNotification {
  reason: NotificationReason;
  name: string;
  description: string;
  channels: NotificationChannel;
  hideEmail: boolean;
}

export interface BackendNotificationSettings {
  id?: number;
  user_id?: number;
  channel_id: number;
  channel_name?: string;
  reason_id: NotificationReasonId;
  reason_name?: NotificationReason;
  item_type_id: NotificationItemTypeId;
  is_enabled: boolean;
}

// Channel mapping: email=1, web=2, mobile=3
export const CHANNEL_IDS = {
  email: 1,
  web: 2,
  mobile: 3,
} as const;

// Each category maps a NotificationReason to its display config and backend reason_id
export const NOTIFICATION_CATEGORIES = [
  {
    reason: NotificationReason.assignment,
    reasonId: NotificationReasonId.assignment,
    name: 'Assigned to you',
    description: 'Get notified when a Rock, To-Do, Issue, or Milestone is assigned to you.',
    hideEmail: false,
  },
  {
    reason: NotificationReason.comment,
    reasonId: NotificationReasonId.comment,
    name: 'Comments',
    description: 'Get notified when someone comments on an item you own or follow.',
    hideEmail: false,
  },
  {
    reason: NotificationReason.mention,
    reasonId: NotificationReasonId.mention,
    name: 'Mentions',
    description: 'Get notified when someone mentions you in a comment.',
    hideEmail: true,
  },
  {
    reason: NotificationReason.itemSent,
    reasonId: NotificationReasonId.itemSent,
    name: 'Headlines & Cascading Messages',
    description: 'Get notified when a headline or cascading message is sent to your team(s).',
    hideEmail: true,
  },
] as const;

// Mapping between legacy event types and NotificationReason for sync
export const EVENT_TYPE_TO_REASON: Partial<Record<string, NotificationReason>> = {
  assignedItem: NotificationReason.assignment,
  commentOnItem: NotificationReason.comment,
};
